import DisclaimerUI from './DisclaimerUI';

export default DisclaimerUI;
